import React from 'react';
import { useLanguage, Locale } from '../../context/LanguageContext';
import './AppChrome.css';

type LanguageToggleProps = {
  compact?: boolean;
};

const LanguageToggle: React.FC<LanguageToggleProps> = ({ compact = false }) => {
  const { locale, setLocale, t } = useLanguage();

  const set = (next: Locale) => {
    setLocale(next);
  };

  return (
    <div
      className={`language-toggle${compact ? ' compact' : ''}`}
      role="group"
      aria-label={t.common.language}
    >
      <button
        type="button"
        className={locale === 'en' ? 'active' : undefined}
        onClick={() => set('en')}
        aria-pressed={locale === 'en'}
      >
        EN
      </button>
      <button
        type="button"
        className={locale === 'fr' ? 'active' : undefined}
        onClick={() => set('fr')}
        aria-pressed={locale === 'fr'}
      >
        FR
      </button>
    </div>
  );
};

export default LanguageToggle;
